import { render, staticRenderFns } from "./appAccountSetting.vue?vue&type=template&id=89d242fa&scoped=true&"
import script from "./appAccountSetting.vue?vue&type=script&lang=js&"
export * from "./appAccountSetting.vue?vue&type=script&lang=js&"
import style0 from "./appAccountSetting.vue?vue&type=style&index=0&id=89d242fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d242fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VFlex,VLayout})
